import { render, staticRenderFns } from "./ChildrenList.vue?vue&type=template&id=59265d39&scoped=true"
import script from "./ChildrenList.vue?vue&type=script&lang=js"
export * from "./ChildrenList.vue?vue&type=script&lang=js"
import style0 from "./ChildrenList.vue?vue&type=style&index=0&id=59265d39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59265d39",
  null
  
)

export default component.exports